import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Shell from "@/components/layout/Shell";
import { PageHeader } from "@/components/common";
import { api } from "@/lib/api";
import { FileText, FileSignature, Receipt, Package } from "lucide-react";
import CotizacionesTab from "@/components/docs/CotizacionesTab";
import ContratosTab from "@/components/docs/ContratosTab";
import CuentasCobroTab from "@/components/docs/CuentasCobroTab";
import ServiciosTab from "@/components/docs/ServiciosTab";

const TABS = [
  { key: "cotizaciones", label: "Cotizaciones", icon: FileText },
  { key: "contratos", label: "Contratos", icon: FileSignature },
  { key: "cuentas", label: "Cuentas de cobro", icon: Receipt },
  { key: "servicios", label: "Servicios", icon: Package },
];

export default function Documentos() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some(t => t.key === params.get("tab")) ? params.get("tab") : "cotizaciones";
  const setTab = (k) => setParams({ tab: k });
  const [data, setData] = useState({ quotes: [], contracts: [], cuentas: [], services: [], clients: [] });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const [q, c, cc, s, cl] = await Promise.all([
        api.get("/quotes"), api.get("/contracts"), api.get("/cuentas-cobro"), api.get("/services"), api.get("/clients"),
      ]);
      setData({ quotes: q.data, contracts: c.data, cuentas: cc.data, services: s.data, clients: cl.data });
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const counts = { cotizaciones: data.quotes.length, contratos: data.contracts.length, cuentas: data.cuentas.length, servicios: data.services.length };

  return (
    <Shell>
      <PageHeader title="Documentos" subtitle="Cotizaciones, contratos y cuentas de cobro con tu marca, listos para descargar en PDF."/>

      <div className="mb-6 flex items-center rounded-xl border border-[#262A33] bg-[#15171E] overflow-x-auto w-fit max-w-full">
        {TABS.map(({ key, label, icon: Icon }, i) => (
          <button key={key} data-testid={`docs-tab-${key}`} onClick={() => setTab(key)}
            className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium whitespace-nowrap transition-colors ${i > 0 ? "border-l border-[#262A33]" : ""} ${
              tab === key ? "bg-[#F97316]/10 text-[#F97316]" : "text-[#9CA3AF] hover:text-[#F5F5F7]"}`}>
            <Icon className="w-4 h-4" strokeWidth={1.75}/> {label}
            <span className={`text-[11px] px-1.5 py-0.5 rounded-md ${tab === key ? "bg-[#F97316]/20" : "bg-[#262A33]"}`}>{counts[key]}</span>
          </button>
        ))}
      </div>

      {loading ? <div className="text-[#9CA3AF]">Cargando…</div> : (
        <>
          {tab === "cotizaciones" && <CotizacionesTab quotes={data.quotes} clients={data.clients} services={data.services} reload={load} onGoContracts={() => setTab("contratos")}/>}
          {tab === "contratos" && <ContratosTab contracts={data.contracts} clients={data.clients} reload={load}/>}
          {tab === "cuentas" && <CuentasCobroTab cuentas={data.cuentas} clients={data.clients} reload={load}/>}
          {tab === "servicios" && <ServiciosTab services={data.services} reload={load}/>}
        </>
      )}
    </Shell>
  );
}
